import { Button, FormInput } from "@farzoom/common-ui-components";
import { Col, Row, Typography } from "antd";
import { useContext, useEffect } from "react";
import { Path, useFieldArray, useFormContext } from "react-hook-form";
import { LotsSubComponent } from "./lots";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { VerticalSpace } from "@app/UI/VerticalSpace";

const { Text } = Typography;

export const IKZList = ({ lotIndex }: LotsSubComponent) => {
  const classes = useStyles();
  const { control, setValue } = useFormContext<BgFormType>();
  const { formDisabled, prefix } = useBgFormContext();

  const currentPrefix = prefix ? `${prefix}.purchase.lots` : `purchase.lots`;

  const {
    fields: list,
    prepend,
    remove,
  } = useFieldArray<BgFormType>({
    control,
    name: `${currentPrefix}.${lotIndex}.ikzList` as any,
  });

  const onAddIKZ = () => {
    // @ts-expect-error - types
    prepend("");
  };

  useEffect(() => {
    if (list.length === 0) {
      // @ts-expect-error - types
      prepend("");
    }
  }, []);

  const onRemove = (idx: number) => remove(idx);

  return (
    <VerticalSpace>
      <Text>
        <div className={classes.actionTitle}>
          <span>Идентификационный код закупки</span>
          {!formDisabled && (
            <Button type="outlined" iconName="add" title="Добавить счет" onClick={onAddIKZ} />
          )}
        </div>
      </Text>
      <VerticalSpace size="small">
        {list.map((item, idx) => (
          <Row key={item.id} gutter={16} align="middle">
            <Col flex="auto">
              <FormInput
                name={`${currentPrefix}.${lotIndex}.ikzList.${idx}`}
                control={control}
                setValue={setValue}
                placeholder="Введите идентификационный код закупки"
              />
            </Col>
            {list.length > 1 && !formDisabled && (
              <Col flex="32px">
                <Button
                  type="outlined"
                  iconName="remove"
                  title="Удалить товар"
                  onClick={() => onRemove(idx)}
                />
              </Col>
            )}
          </Row>
        ))}
      </VerticalSpace>
    </VerticalSpace>
  );
};
